'use strict';
import angular from 'angular';
import $ from 'jquery';
import './widget.library.constants';
import './base/widget.library.components';
import './base/widget.library.services';
import './base/widget.library.resources';
import './base/widget.library.models';
import './tags/widget.tag.services';
import './tags/widget.tag.resources';

import manageWidgetLibraryHtmlUrl from './base/managewidgetlibrary.html';
import manageWidgetTagsHtmlUrl from './tags/managewidgettags.html';

angular.module('widget.library', [
    'widget.library.constants',
    'widget.library.models',
    'widget.library.components',
    'widget.library.services',
    'widget.library.resources',
    'widget.tag.services',
    'widget.tag.resources'
])
    .config(['$stateProvider', 'SwitchAppServiceProvider', function ($stateProvider, SwitchAppServiceProvider) {

        $stateProvider.state('managewidgetlibrary', {
            parent:'layout',
            url: '/managewidgetlibrary',
            resolve: {
                isTARoute: SwitchAppServiceProvider.switchAppFn('managewidgetlibrary'),
                pageType: function(PageType) {
                    return PageType.TYPE_ADMIN;
                },
                pageEntity: function(PageEntity) {
                    return PageEntity.PAGE_MANAGE_WIDGET_LIBRARY;
                },
                vars: function() {
                    return null;
                }
            },
            views: {
                '': {
                    templateUrl: manageWidgetLibraryHtmlUrl,
                    controller: 'DesignController'
                }
            }
        })
            .state('managewidgettags', {
                parent:'layout',
                url: '/managewidgettags',
                resolve: {
                    isTARoute: SwitchAppServiceProvider.switchAppFn('managewidgettags'),
                    pageType: function(PageType) {
                        return PageType.TYPE_ADMIN;
                    },
                    pageEntity: function(PageEntity) {
                        return PageEntity.PAGE_MANAGE_WIDGET_TAGS;
                    },
                    vars: function() {
                        return null;
                    }
                },
                views: {
                    '': {
                        templateUrl: manageWidgetTagsHtmlUrl,
                        controller: 'DesignController'
                    }
                }
            })
    }]);